module.exports = __webpack_public_path__ + "img/V-R-4-unload-connect.0896649c.png";